import React from "react";

import { XMarkIcon } from "@heroicons/react/24/solid";

import { Button } from "@cgc/ui/button";
import { Paragraph } from "@cgc/ui/typography";
import { useCurrentRefinements } from "react-instantsearch";

const BlogCurrentRefinements: React.FC = () => {
  const { items, canRefine } = useCurrentRefinements({
    includedAttributes: ["category", "tag", "query"],
  });

  if (!canRefine) {
    return null;
  }

  return (
    <div className="sm:left my-2 flex flex-row justify-center gap-1 lg:absolute lg:-top-[78px] lg:justify-start">
      {items.map((item, index) => (
        <React.Fragment key={`${item.indexId}:${item.attribute}:${index}`}>
          {item.refinements.map((refinement) => (
            <Button
              color="unstyled"
              key={`${refinement.attribute}:${refinement.value}:${item.indexId}`}
              onClick={() => item.refine(refinement)}
              className="border-cgc-green rounded-none border-[1px] border-solid"
              typoComponent={() => (
                <Paragraph
                  size="sub3"
                  as="span"
                  className="flex flex-row items-center"
                >
                  {refinement.label} <XMarkIcon className="-mt-1 h-4 w-4" />
                </Paragraph>
              )}
            />
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};

export default BlogCurrentRefinements;
